import { render } from "./page-armada-selengkapnya.vue?vue&type=template&id=65b64496&scoped=true"
import script from "./page-armada-selengkapnya.vue?vue&type=script&lang=js"
export * from "./page-armada-selengkapnya.vue?vue&type=script&lang=js"

import "./page-armada-selengkapnya.vue?vue&type=style&index=0&id=65b64496&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b64496"]])

export default __exports__